import { useContext } from 'react'
import { ContentContext } from './ContentContext'

/**
 * Re-reads the site content from the API.
 *
 * Separate from `useContent` because the pages only ever read content, and
 * a component that can trigger a refetch is a different capability from one
 * that renders. Only the admin panel needs it.
 */
export const useContentRefresh = (): (() => Promise<void>) => {
  const context = useContext(ContentContext)
  if (!context) {
    throw new Error('useContentRefresh must be used inside a ContentProvider')
  }
  return context.refresh
}
